import React from 'react';

const Members = ({ users }) => {
  // console.log(users);
  return (
    <div className='members'>
      {users.length > 0 ? (
        <div>
          <ul className='list-group list-group-numbered'>
            {users.users.map(({ name }) => (
              <li className='list-group-item' key={name}>
                {name}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default Members;
